import React from 'react';
import { Clock, TrendingUp, Wallet } from 'lucide-react';

// Extracted from WorkerDashboard.js — receives everything it needs via `ctx`.
export default function WorkerWalletTab({ ctx }) {
  const { FinancialSummaryCard, FinancialTimeline, StatementDownload, TransactionsList, activeTab, wallet, walletTxns } = ctx;
  return (
    <>
    {activeTab === 'wallet' && (
      <div className="space-y-6">
        {/* Header */}
        <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl p-6 text-white">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-white/20 backdrop-blur-sm rounded-xl">
              <Wallet className="w-6 h-6" />
            </div>
            <div>
              <h2 className="text-3xl font-bold">Wallet & Earnings</h2>
              <p className="text-white/90">Track your income and manage payouts</p>
            </div>
          </div>
        </div>

        {wallet && (
          <div className="space-y-6">
            {/* Balance Card */}
            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 p-8 text-white">
              <div className="relative z-10">
                <div className="text-center mb-8">
                  <p className="text-lg text-white/80 mb-3 font-medium">Available Balance</p>
                  <p className="text-6xl font-bold tabular-nums mb-6 drop-shadow-lg" data-testid="wallet-balance-main">
                    ${wallet.balance?.toFixed(2) || '0.00'}
                  </p>
                  <div className="flex items-center justify-center gap-2 text-white/70">
                    <TrendingUp className="w-5 h-5" />
                    <span>Ready for withdrawal</span>
                  </div>
                </div>
              </div>
              
              {/* Decorative elements */}
              <div className="absolute -right-20 -top-20 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
              <div className="absolute -left-20 -bottom-20 w-80 h-80 bg-yellow-400/20 rounded-full blur-3xl"></div>
            </div>

            {/* Stats — sourced from the centralized Financial Engine */}
            <FinancialSummaryCard />

            {/* Phase 4: engine-sourced financial activity timeline */}
            <FinancialTimeline />

            {/* Recent Transactions — unified wallet_transactions history */}
            <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                  <Clock className="w-5 h-5 text-blue-600" />
                  Recent Transactions
                </h3>
              </div>
              <div className="p-6">
                <TransactionsList transactions={walletTxns.slice(0, 10)} />
              </div>
            </div>

            {/* Monthly payout statement download */}
            <StatementDownload />
          </div>
        )}
      </div>
    )}
    </>
  );
}
